// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .Loader-saving-PX69S {
 	font-size: 18px;
 	color: var(--btn-primary-bg);
 }

 .Loader-savingDots-H5Rx6 {
 	font-size: 48px;
 }

 .Loader-saving-PX69S span {
 	-webkit-animation-name: Loader-blink-x6pAj;
 	        animation-name: Loader-blink-x6pAj;
 	-webkit-animation-duration: 1.4s;
 	        animation-duration: 1.4s;
 	-webkit-animation-iteration-count: infinite;
 	        animation-iteration-count: infinite;
 	-webkit-animation-fill-mode: both;
 	        animation-fill-mode: both;
 	color: var(--btn-primary-bg);
 }

 .Loader-saving-PX69S span:nth-child(2) {
 	-webkit-animation-delay: .2s;
 	        animation-delay: .2s;
 }

 .Loader-saving-PX69S span:nth-child(3) {
 	-webkit-animation-delay: .4s;
 	        animation-delay: .4s;
 }

 @-webkit-keyframes Loader-blink-x6pAj {
 	0% {
 		opacity: .2;
 	}

 	20% {
 		opacity: 1;
 	}

 	100% {
 		opacity: .2;
 	}
 }

 @keyframes Loader-blink-x6pAj {
 	0% {
 		opacity: .2;
 	}

 	20% {
 		opacity: 1;
 	}

 	100% {
 		opacity: .2;
 	}
 }

 .Loader-textCenter-Yuyzu {
 	text-align: center;
 }

 .Loader-iconColor-UCpl5 {
 	color: var(--btn-primary-bg);
 	font-size: 48px;
 }

 /* custom circle loader */

 .Loader-customCircleLoad-rGzws {
 	border-radius: 50%;
 	border-style: solid;
 	-webkit-animation:
 		Loader-customCircleOne-qYpW4 0.8s infinite linear alternate,
 		Loader-customCircleTwo-jxuIe 1.6s infinite linear;
 	        animation:
 		Loader-customCircleOne-qYpW4 0.8s infinite linear alternate,
 		Loader-customCircleTwo-jxuIe 1.6s infinite linear;
 	display: inline-block;
 	vertical-align: middle;
 	-ms-flex-negative: 0;
 	    flex-shrink: 0;
 }

 @-webkit-keyframes Loader-customCircleOne-qYpW4 {
 	0% {
 		clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)
 	}

 	12.5% {
 		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)
 	}

 	25% {
 		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)
 	}

 	50% {
 		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
 	}

 	62.5% {
 		clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
 	}

 	75% {
 		clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)
 	}

 	100% {
 		clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)
 	}
 }

 @keyframes Loader-customCircleOne-qYpW4 {
 	0% {
 		clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)
 	}

 	12.5% {
 		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)
 	}

 	25% {
 		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)
 	}

 	50% {
 		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
 	}

 	62.5% {
 		clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
 	}

 	75% {
 		clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)
 	}

 	100% {
 		clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)
 	}
 }

 @-webkit-keyframes Loader-customCircleTwo-jxuIe {
 	0% {
 		-webkit-transform: scaleY(1) rotate(0deg);
 		        transform: scaleY(1) rotate(0deg)
 	}

 	49.99% {
 		-webkit-transform: scaleY(1) rotate(135deg);
 		        transform: scaleY(1) rotate(135deg)
 	}

 	50% {
 		-webkit-transform: scaleY(-1) rotate(0deg);
 		        transform: scaleY(-1) rotate(0deg)
 	}

 	100% {
 		-webkit-transform: scaleY(-1) rotate(-135deg);
 		        transform: scaleY(-1) rotate(-135deg)
 	}
 }

 @keyframes Loader-customCircleTwo-jxuIe {
 	0% {
 		-webkit-transform: scaleY(1) rotate(0deg);
 		        transform: scaleY(1) rotate(0deg)
 	}

 	49.99% {
 		-webkit-transform: scaleY(1) rotate(135deg);
 		        transform: scaleY(1) rotate(135deg)
 	}

 	50% {
 		-webkit-transform: scaleY(-1) rotate(0deg);
 		        transform: scaleY(-1) rotate(0deg)
 	}

 	100% {
 		-webkit-transform: scaleY(-1) rotate(-135deg);
 		        transform: scaleY(-1) rotate(-135deg)
 	}
 }`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.css"],"names":[],"mappings":"CAAC;EACC,eAAe;EACf,4BAA4B;CAC7B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,0CAAqB;UAArB,kCAAqB;EACrB,gCAAwB;UAAxB,wBAAwB;EACxB,2CAAmC;UAAnC,mCAAmC;EACnC,iCAAyB;UAAzB,yBAAyB;EACzB,4BAA4B;CAC7B;;CAEA;EACC,4BAAoB;UAApB,oBAAoB;CACrB;;CAEA;EACC,4BAAoB;UAApB,oBAAoB;CACrB;;CAEA;EACC;GACC,WAAW;EACZ;;EAEA;GACC,UAAU;EACX;;EAEA;GACC,WAAW;EACZ;CACD;;CAZA;EACC;GACC,WAAW;EACZ;;EAEA;GACC,UAAU;EACX;;EAEA;GACC,WAAW;EACZ;CACD;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;EAC5B,eAAe;CAChB;;CAEA,yBAAyB;;CAEzB;EACC,kBAAkB;EAClB,mBAAmB;EACnB;;oDAEqC;UAFrC;;oDAEqC;EACrC,qBAAqB;EACrB,sBAAsB;EACtB,oBAAc;MAAd,cAAc;CACf;;CAEA;EACC;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;CACD;;CA5BA;EACC;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;;EAEA;GACC;EACD;CACD;;CAEA;EACC;GACC,yCAAgC;WAAhC;EACD;;EAEA;GACC,2CAAkC;WAAlC;EACD;;EAEA;GACC,0CAAiC;WAAjC;EACD;;EAEA;GACC,6CAAoC;WAApC;EACD;CACD;;CAhBA;EACC;GACC,yCAAgC;WAAhC;EACD;;EAEA;GACC,2CAAkC;WAAlC;EACD;;EAEA;GACC,0CAAiC;WAAjC;EACD;;EAEA;GACC,6CAAoC;WAApC;EACD;CACD","sourcesContent":[" .saving {\n \tfont-size: 18px;\n \tcolor: var(--btn-primary-bg);\n }\n\n .savingDots {\n \tfont-size: 48px;\n }\n\n .saving span {\n \tanimation-name: blink;\n \tanimation-duration: 1.4s;\n \tanimation-iteration-count: infinite;\n \tanimation-fill-mode: both;\n \tcolor: var(--btn-primary-bg);\n }\n\n .saving span:nth-child(2) {\n \tanimation-delay: .2s;\n }\n\n .saving span:nth-child(3) {\n \tanimation-delay: .4s;\n }\n\n @keyframes blink {\n \t0% {\n \t\topacity: .2;\n \t}\n\n \t20% {\n \t\topacity: 1;\n \t}\n\n \t100% {\n \t\topacity: .2;\n \t}\n }\n\n .textCenter {\n \ttext-align: center;\n }\n\n .iconColor {\n \tcolor: var(--btn-primary-bg);\n \tfont-size: 48px;\n }\n\n /* custom circle loader */\n\n .customCircleLoad {\n \tborder-radius: 50%;\n \tborder-style: solid;\n \tanimation:\n \t\tcustomCircleOne 0.8s infinite linear alternate,\n \t\tcustomCircleTwo 1.6s infinite linear;\n \tdisplay: inline-block;\n \tvertical-align: middle;\n \tflex-shrink: 0;\n }\n\n @keyframes customCircleOne {\n \t0% {\n \t\tclip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)\n \t}\n\n \t12.5% {\n \t\tclip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)\n \t}\n\n \t25% {\n \t\tclip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)\n \t}\n\n \t50% {\n \t\tclip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)\n \t}\n\n \t62.5% {\n \t\tclip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)\n \t}\n\n \t75% {\n \t\tclip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)\n \t}\n\n \t100% {\n \t\tclip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)\n \t}\n }\n\n @keyframes customCircleTwo {\n \t0% {\n \t\ttransform: scaleY(1) rotate(0deg)\n \t}\n\n \t49.99% {\n \t\ttransform: scaleY(1) rotate(135deg)\n \t}\n\n \t50% {\n \t\ttransform: scaleY(-1) rotate(0deg)\n \t}\n\n \t100% {\n \t\ttransform: scaleY(-1) rotate(-135deg)\n \t}\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"saving": `Loader-saving-PX69S`,
	"savingDots": `Loader-savingDots-H5Rx6`,
	"blink": `Loader-blink-x6pAj`,
	"textCenter": `Loader-textCenter-Yuyzu`,
	"iconColor": `Loader-iconColor-UCpl5`,
	"customCircleLoad": `Loader-customCircleLoad-rGzws`,
	"customCircleOne": `Loader-customCircleOne-qYpW4`,
	"customCircleTwo": `Loader-customCircleTwo-jxuIe`
};
module.exports = ___CSS_LOADER_EXPORT___;
